export default function CsharpWrite() {
  return (
    <h2>Csharp Write</h2>
  );
}
